import routerDefault from '@/router/routerDefault'
import routerGzs from '@/router/routerGzs' // 贵州人设厅
import routerCdjg from '@/router/routerCdjg' // 成都建工
import routerCd from '@/router/routerCd' // 成都
import routerGy from '@/router/routerGy' // 贵阳
import routerCq3 from '@/router/routerCq3' // 重庆新
import routerGzzj from '@/router/routerGzzj.js' // 贵州住建厅
import routerGztr from '@/router/routerGztr.js' // 贵州省铜仁市建委
import routerHn from '@/router/routerHn.js' // 海南市建委
import routerLz from '@/router/routerLz.js' // 泸州
import routerCqCt from '@/router/routerCqCt.js' // 重庆市建委 + 城投 / 重庆两江新区 + 城投
import routerCq3Ct from '@/router/routerCq3Ct.js' // 重庆市建委1.0 + 城投
import routerCqmohrss from '@/router/routerCqmohrss.js' // 重庆市人社局
import routerCqmohrssCq3 from '@/router/routerCqmohrssCq3.js' // 重庆市人社局 + 重庆市建委1.0
import routerCq2 from '@/router/routerCq2.js' // 重庆市建委2.0
import routerCq2Cqmohrss from '@/router/routerCq2Cqmohrss.js' // 重庆市建委2.0 + 重庆市人社局
import routerGld from '@/router/routerGld.js' // 广联达
import routerCq2Zjygjxm from '@/router/routerCq2Zjygjxm.js' // 中建一公局厦门
import routerQzy from '@/router/routerQzy.js' // 轻筑云
import routerHx from '@/router/routerHx.js' // 华西
import routerGzzjkj from '@/router/routerGzzjkj.js' // 中建
import routerQb from '@/router/routerQb.js' // 千变
import routerCdjgGld from '@/router/routerCdjgGld.js' // 成都建工-广联达版
import routerCqdc2 from '@/router/routerCqdc2.js' // 重庆地产2.0
import routerCqddk from '@/router/routerCqddk.js' // 重庆地产2.0
import routerCq2Cqmohrss2 from '@/router/routerCq2Cqmohrss2.js' // 重庆人社局2.0

import APP from '@/utils/base'

const REGION_ROUTER = { // 如修改此处,另需修改util.js
    '1': routerDefault, // 重庆市建委 默认
    '2': routerDefault, // 重庆市两江新区 默认
    '3': routerCd, // 成都市建委
    '4': routerDefault, // 永川普天 默认
    '5': routerDefault, // 渝高 默认
    '12': routerGzs, // 贵州省人社厅
    '15': routerCdjg, // 成都建工
    '19': routerGy, // 贵阳市建委
    '3,15': routerCdjg, // 成都市建委+成都建工
    '3,16': routerCd, // 成都市建委+成都环境投资
    '1,18': routerDefault, // 重庆市建委（温华） 默认
    '12,19': routerGy, // 贵州省人社厅 + 贵阳市建委
    '20': routerCq3, // 重庆市建委1.0

    '23': routerGzzj, // 贵州省住建厅
    '12,23': routerGzzj, // 贵州省人社厅 + 贵州省住建厅

    '24': routerHn, // 海南市建委
    '25': routerLz, // 泸州
    '1,22': routerCqCt, // 重庆市建委 + 城投
    '2,22': routerCqCt, // 重庆两江新区 + 城投
    '20,22': routerCq3Ct, // 重庆市建委1.0 + 城投
    '1,5': routerDefault, // 重庆市建委 + 渝高
    '2,5': routerDefault, // 重庆市两江新区 + 渝高
    '5,20': routerDefault, // 重庆市建委1.0 + 渝高

    '28': routerCqmohrss, // 重庆市人社局
    '1,28': routerCqmohrss, // 重庆市人社局 + 重庆市建委
    '2,28': routerCqmohrss, // 重庆市人社局 + 重庆两江新区
    '20,28': routerCqmohrssCq3, // 重庆市人社局 + 重庆市建委1.0

    '1,29': routerDefault, // 重庆市高新区 + 重庆市建委
    '20,29': routerCq3, // 重庆市高新区 + 重庆市建委1.0
    '1,28,29': routerCqmohrss, // 重庆市高新区 + 重庆市人社局 + 重庆市建委
    '20,28,29': routerCqmohrssCq3, // 重庆市高新区 + 重庆市人社局 + 重庆市建委1.0

    '31': routerCq2, // 重庆市建委2.0
    '22,31': routerCq2, // 重庆市建委2.0 + 城投
    '29,31': routerCq2, // 重庆市建委2.0 + 重庆市高新区
    '28,31': routerCq2Cqmohrss, // 重庆市建委2.0 + 重庆市人社局
    '28,29,31': routerCq2Cqmohrss, // 重庆市建委2.0 + 重庆市人社局 + 重庆市高新区
    '2,28,31': routerCq2Cqmohrss, // 重庆市建委2.0 + 重庆市人社局 + 重庆市两江新区

    '32': routerGztr, // 贵州省铜仁市建委
    '12,32': routerGztr, // 贵州省铜仁市建委 + 贵州省人社厅

    '34': routerGld, // 广联达
    '2,34': routerGld, // 广联达 + 重庆市两江新区
    '28,34': routerGld, // 广联达 + 重庆市人社局
    '31,34': routerGld, // 广联达 + 重庆市建委2.0
    '2,28,34': routerGld, // 广联达 + 重庆市两江新区 + 重庆市人社局
    '28,31,34': routerGld, // 广联达 + 重庆市建委2.0 + 重庆市人社局

    '31,35': routerCq2Zjygjxm, // 重庆市建委2.0 + 中交一公局厦门公司
    '28,31,35': routerCq2Zjygjxm, // 重庆市建委2.0 + 中交一公局厦门公司 + 重庆市人社局

    '37': routerQzy, // 轻筑云
    '2,37': routerQzy, // 轻筑云 + 重庆市两江新区
    '28,37': routerQzy, // 轻筑云 + 重庆市人社局
    '31,37': routerQzy, // 轻筑云 + 重庆市建委2.0
    '2,28,37': routerQzy, // 轻筑云 + 重庆市两江新区 + 重庆市人社局
    '28,31,37': routerQzy, // 轻筑云 + 重庆市建委2.0 + 重庆市人社局

    '38': routerHx, // 华西
    '2,38': routerHx, // 华西 + 重庆市两江新区
    '28,38': routerHx, // 华西 + 重庆市人社局
    '31,38': routerHx, // 华西 + 重庆市建委2.0
    '2,28,38': routerHx, // 华西 + 重庆市两江新区 + 重庆市人社局
    '28,31,38': routerHx, // 华西 + 重庆市建委2.0 + 重庆市人社局

    '12,39': routerGzzjkj, // 贵州省人社厅+中建

    '41': routerQb, // 千变
    '2,41': routerQb, // 千变 + 重庆市两江新区
    '28,41': routerQb, // 千变 + 重庆市人社局
    '31,41': routerQb, // 千变 + 重庆市建委2.0
    '2,28,41': routerQb, // 千变 + 重庆市两江新区 + 重庆市人社局
    '28,31,41': routerQb, // 千变 + 重庆市建委2.0 + 重庆市人社局

    '46': routerCdjgGld, // 成都建工-广联达版
    '2,46': routerCdjgGld, // 成都建工-广联达版 + 重庆市两江新区
    '28,46': routerCdjgGld, // 成都建工-广联达版 + 重庆市人社局
    '31,46': routerCdjgGld, // 成都建工-广联达版 + 重庆市建委2.0
    '2,28,46': routerCdjgGld, // 成都建工-广联达版 + 重庆市两江新区 + 重庆市人社局
    '28,31,46': routerCdjgGld, // 成都建工-广联达版 + 重庆市建委2.0 + 重庆市人社局

    '47': routerCqdc2, // 重庆地产2.0
    '2,47': routerCqdc2, // 重庆地产2.0 + 重庆市两江新区
    '28,47': routerCqdc2, // 重庆地产2.0 + 重庆市人社局
    '31,47': routerCqdc2, // 重庆地产2.0 + 重庆市建委2.0
    '2,28,47': routerCqdc2, // 重庆地产2.0 + 重庆市两江新区 + 重庆市人社局
    '28,31,47': routerCqdc2, // 重庆地产2.0 + 重庆市建委2.0 + 重庆市人社局

    '48': routerCqddk, // 重庆市大渡口区
    '2,48': routerCqddk, // 重庆市大渡口区 + 重庆市两江新区
    '28,48': routerCqddk, // 重庆市大渡口区 + 重庆市人社局
    '31,48': routerCqddk, // 重庆市大渡口区 + 重庆市建委2.0
    '2,28,48': routerCqddk, // 重庆市大渡口区 + 重庆市两江新区 + 重庆市人社局
    '28,31,48': routerCqddk, // 重庆市大渡口区 + 重庆市建委2.0 + 重庆市人社局
        '34,48': routerCqddk, // 重庆市大渡口区 + 广联达
    '31,34,48': routerCqddk, // 重庆市大渡口区 + 广联达 + 重庆市建委2.0
    '37,48': routerCqddk, // 重庆市大渡口区 + 轻筑云
    '31,37,48': routerCqddk, // 重庆市大渡口区 + 轻筑云 + 重庆市建委2.0
    '48,50': routerCqddk, // 重庆市大渡口区 + 重庆人社局2.0
    '31,48,50': routerCqddk, // 重庆市大渡口区 + 重庆人社局2.0 + 重庆市建委2.0
    '48,51': routerCqddk, // 重庆市大渡口区 + 重庆市建委3.0
    '31,48,51': routerCqddk, // 重庆市大渡口区 + 重庆市建委3.0 + 重庆市建委2.0
    '48,50,51': routerCqddk, // 重庆市大渡口区 + 重庆市建委3.0 + 重庆人社局2.0
    '31,48,50,51': routerCqddk, // 重庆市大渡口区 + 重庆市建委3.0 + 重庆市建委2.0 + 重庆人社局2.0

    '50': routerCq2Cqmohrss2, // 重庆人社局2.0
    '31,50': routerCq2Cqmohrss2, // 重庆人社局2.0 + 重庆市建委2.0
    '37,50': routerQzy, // 重庆人社局2.0 + 轻筑云
    '31,37,50': routerQzy, // 重庆人社局2.0 + 轻筑云 + 重庆市建委2.0
    '34,50': routerGld, // 重庆人社局2.0 + 广联达
    '31,34,50': routerGld, // 重庆人社局2.0 + 广联达 + 重庆市建委2.0

    '51': routerQzy, // 重庆市建委3.0
    '31,51': routerQzy, // 重庆市建委3.0 + 重庆市建委2.0
    '50,51': routerQzy, // 重庆市建委3.0 + 重庆人社局2.0
    '31,50,51': routerQzy, // 重庆市建委3.0 + 重庆市建委2.0+ 重庆人社局2.0
    '37,51': routerQzy, // 重庆市建委3.0 + 轻筑云
    '31,37,51': routerQzy, // 重庆市建委3.0 + 轻筑云 + 重庆市建委2.0
    '31,37,50,51': routerQzy, // 重庆市建委3.0 + 轻筑云 + 重庆市建委2.0 + 重庆人社局2.0
    '34,51': routerGld, // 重庆市建委3.0 + 广联达
    '31,34,51': routerGld, // 重庆市建委3.0 + 广联达 + 重庆市建委2.0
    '31,34,50,51': routerGld, // 重庆市建委3.0 + 广联达 + 重庆市建委2.0 + 重庆人社局2.0
}
const state = {
    routes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = routes
    }
}

const actions = {
    generateRoutes({
        commit
    }, regionId) {
        return new Promise(resolve => {
            let accessedRoutes = []
            if (regionId) {
                let _regionArrDivision = regionId.split(',')
                let _regionArr = []
                for (let i = 0; i < _regionArrDivision.length; i++) {
                    if (_regionArrDivision[i] === '' ||
                        _regionArrDivision[i] === '5' ||
						_regionArrDivision[i] === '21' ||
                        _regionArrDivision[i] === '30'||
                        _regionArrDivision[i] === '40'||
                        _regionArrDivision[i] === '42') {
                        continue;
                    }
                    _regionArr.push(_regionArrDivision[i])
                }
                _regionArr = _regionArr.sort((a, b) => {
                    return a - b
                })
                regionId = _regionArr.join(',')
            }
            if (REGION_ROUTER.hasOwnProperty(regionId)) {
                accessedRoutes = REGION_ROUTER[regionId]
            } else {
                if (regionId === '') {
                    // 如果区域不是默认也不是路由中的其他路由，调用方法跳转至原项目端
                    accessedRoutes = routerDefault
                } else {
                    // APP.goProject()
                }
            }

            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
        })
    }
}

export default {
    namespace: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js